import { TanStackDevtools } from "@tanstack/react-devtools";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";
import { DebugTransactionIdBadge } from "../components/DebugTransactionIdBadge";
import { FeatureFlagsInitializer } from "../components/FeatureFlagsInitializer";
import { IOSIntegrationInitializer } from "../components/IOSIntegrationInitializer";
import { AppShell } from "../components/layout/AppShell";
import { ParentMessageInitializer } from "../components/ParentMessageInitializer";
import { PrepareInitializer } from "../components/PrepareInitializer";
import { SessionInitializer } from "../components/SessionInitializer";
import { URLParamsInitializer } from "../components/URLParamsInitializer";

import { Toaster } from "../components/ui/sonner";
import TanStackQueryDevtools from "../integrations/tanstack-query/devtools";
import RampsStoreDevtools from "../lib/ramps-store-devtools";

export interface MyRouterContext {
	queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: () => (
		<>
			<FeatureFlagsInitializer />
			<URLParamsInitializer />
			<PrepareInitializer />
			<SessionInitializer />
			<IOSIntegrationInitializer />
			<ParentMessageInitializer />
			<Toaster />
			<DebugTransactionIdBadge />
			{/*
			 * RAMPS-4444: every route renders inside AppShell so the page width
			 * is capped in exactly one place. This is the root route rather than
			 * `ramps.tsx` because `/transaction-status` is a sibling of
			 * `/ramps`, not a child. Toaster and the devtools stay outside it.
			 */}
			<AppShell>
				<Outlet />
			</AppShell>
			<TanStackDevtools
				config={{
					position: "bottom-left",
				}}
				plugins={[
					{
						name: "Tanstack Router",
						render: <TanStackRouterDevtoolsPanel />,
					},
					RampsStoreDevtools,
					TanStackQueryDevtools,
				]}
			/>
		</>
	),
});
